import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router, RouterModule } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { GuardianDto } from "@malirang/api-client";
import { Gender, Relationship } from "@malirang/common";
import { Icon, ModalService } from "@malirang/front-share";
import { injectResize } from "ngxtension/resize";
import { ChildStore } from "../../../stores/child.store";
import { NotificationStore } from "../../../stores/notification.store";
import { UserStore } from "../../../stores/user.store";
import { MypageStore } from "../../my-page/store/my-page.store";
import SideMenuComponent from "../side-menu/side-menu.component";
import SelectChildComponent from "./components/select-child/select-child";

@Component({
    selector: "app-header",
    standalone: true,
    imports: [CommonModule, Icon, CdkMenuModule, RouterModule],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
})
export default class HeaderComponent {
    private readonly modalService = inject(ModalService);
    private readonly router = inject(Router);
    private readonly mypageStore = inject(MypageStore);
    protected readonly childStore = inject(ChildStore);
    protected readonly user = inject(UserStore).user;
    protected readonly notificationStore = inject(NotificationStore);

    isNativeApp = computed(() => Capacitor.isNativePlatform());

    resize$ = injectResize();

    notificationCount = toSignal(this.notificationStore.count$);
    Gender = Gender;
    Relationship = Relationship;

    guardianInfo = computed<GuardianDto>(
        () =>
            this.childStore
                .selectedChild$()
                ?.guardians?.find(
                    (g) => g?.parent?.id === this.user()?.id,
                ) as GuardianDto,
    );

    /**
     * @name handleSidebar
     * @description 사이드바를 엽니다.
     * @returns {void}
     */
    handleSidebar(): void {
        this.modalService.create(SideMenuComponent);
    }

    /**
     * @name openModal
     * @description 아동 목록 모달을 엽니다.
     * @param {Event} ev
     * @returns {void}
     */
    openModal(ev?: Event): void {
        ev?.stopPropagation();
        ev?.preventDefault();

        const modal = this.modalService.create(SelectChildComponent, {});

        modal.closed.subscribe((res) => {
            if (res) this.router.navigate([res]);
        });
    }

    /**
     * @name moveToNotification
     * @description move to notification page
     * @param {Event} ev
     * @returns {void}
     */
    moveToNotification(ev?: Event): void {
        ev?.stopPropagation();
        this.router.navigate(["/my-page"]);
        this.mypageStore.setSelectedSegment("notification");
    }
}
